import * as Yup from 'yup';

export const schema = Yup.object({
	logoBase64: Yup.string().nullable().required('').min(8),
});
